'use client'
import { formatSaleChange } from '@/utils/market-metrics'

/**
 * The 7d change of a market's fair price, as the API computes it
 * (`change_week_fair`). No second method: a market the keeper has not
 * priced yet reads N/A rather than a number from a different calculation.
 */
export default function SaleChange({ existing }: { slug?: string; existing: number | null; fungible?: boolean }) {
 const value = existing
 const neutral = value === null || Math.abs(value) < 0.005
 const explanation = value !== null
  ? '7d change of the fair price: where an ordinary piece has been clearing, from cross-market sales, today vs seven days ago.'
  : 'No fair price history yet.'
 return <span title={explanation} className={neutral ? 'text-muted-foreground' : value! > 0 ? 'text-emerald-600 dark:text-emerald-400' : 'text-rose-500'}>
  {formatSaleChange(value)}
 </span>
}
